module.exports = __webpack_public_path__ + "media/images/ns-app-battery-icon-40-4c38952710cf1337d15a9422e133e358.svg";